import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../deps';

import './Control.scss';

const { bool, string, func, array, object } = PropTypes;
export default class extends React.PureComponent {
  static propTypes = {
    enabled: bool,
    looksDisabled: bool,
    qaTag: string,
    className: string,
    iconClassName: string,
    styleNames: array,
    onClick: func,
    glyph: string,
    title: string,
    ariaAttributes: object,
    buttonType: string,
  };

  static defaultProps = {
    enabled: true,
    className: '',
    iconClassName: '',
    styleNames: [],
    buttonType: 'button',
    onClick: () => {},
  };

  state = {
    showOutline: false,
  };

  onKeyUp = e => {
    const key = e.which || e.keyCode;
    if (key === D.Constants.App.KeyCodes.TAB) {
      this.setState({ showOutline: true });
    }
  };

  onBlur = () => {
    this.setState({ showOutline: false });
  };

  render() {
    const classes = classNames(
      this.props.className,
      D.Utils.Css.createBEM('TunerControl', {
        access: this.state.showOutline,
        disabled: this.props.looksDisabled,
        ...this.props.styleNames.reduce((acc, curr) => {
          acc[curr] = true;
          return acc;
        }, {}),
      }),
    );
    const iconClasses = classNames('TunerControl__Icon', this.props.iconClassName);
    const focusableProps = {
      focusable: 'false',
    };

    return (
      <button
        type={this.props.buttonType}
        onKeyUp={this.onKeyUp}
        onBlur={this.onBlur}
        data-qa={this.props.qaTag}
        className={classes}
        onClick={this.props.onClick}
        disabled={!this.props.enabled}
        aria-label={this.props.title}
        {...this.props.ariaAttributes}
      >
        <D.Icon className={iconClasses} glyph={this.props.glyph} {...focusableProps} />
      </button>
    );
  }
}
